"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function sngls(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.699 15.5617L12 16.8637L11.301 15.5617C7.0785 15.234 3.76425 12.0855 3.76425 12.0855C3.76425 12.078 6.98475 9.02698 11.121 8.62498L11.6685 7.68748L12 7.13623L12.5625 8.07373L12.879 8.62498C17.0145 9.01948 20.2358 12.0855 20.2358 12.0855C20.2358 12.0855 16.9208 15.234 12.6983 15.5617H12.699ZM4.46325 12.0855C4.45575 12.0855 7.64775 14.2665 10.854 14.7277L9.291 11.8027L9.7155 11.0662L10.1055 11.7952L10.098 11.8027L11.6183 14.7952C11.7405 14.8027 11.8628 14.8027 11.9858 14.8027C12.108 14.8027 12.2235 14.8027 12.3458 14.7952L13.4625 12.5692L14.277 11.0512L14.7015 11.7877L13.1385 14.7202C16.3448 14.2665 19.536 12.138 19.536 12.078C19.536 12.0255 16.4963 9.99448 13.3688 9.47323L13.8443 10.2997L13.4483 11.0955L12.4178 9.36898C12.2787 9.36027 12.1394 9.35527 12 9.35398C11.8628 9.35398 11.7188 9.36148 11.5748 9.36898L10.5225 11.0955L10.134 10.3365L10.6305 9.48073C7.50375 10.0095 4.46325 12.0855 4.46325 12.0855Z", fill: color }));
}
exports["default"] = sngls;
//# sourceMappingURL=sngls.js.map